import styled from "styled-components"
import ResultsCard from "../childDashboard/components/ResultsCard"
import { COLORS } from "../../constants"
import { Link, useHistory } from "react-router-dom"
import { CustomButton } from "../../components"
import { useState, useEffect } from "react"
import { useSelector } from "react-redux"
import { staticLevelData, levelcolors } from "../../constants"
import { BlobProvider } from '@react-pdf/renderer';
import { PDFDownloadLink, Document, Page } from '@react-pdf/renderer';
import MyDoc from "../../pdf/Worksheet"
import axios from "axios"

const StyledCardContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-left: -5px;
    margin-right: -5px;
    margin-top: 10px;
`;

export default function Levels() {
    const api = process.env.REACT_APP_API_URL;
    const [data, setData] = useState([]);
    const user = useSelector(state => state.auth.user.user)
    const history = useHistory();
    useEffect(async () => {
        try {
            const response = await axios.get(`${api}/ps/puchased_games/${user.email}`);
            const data = response.data.levels;
            if (data) {
                setData(fixArray(data))
                // setLoading(false)
            }
        } catch (error) {
            console.log(error)
            // setLoading(false)
        }
    }, [])

    const fixArray = (data) => {
        let parentLevels = [];

        for (var i = 0; i < 6; i++) {

            if (!data.find(element => element.level_no == i + 1)) {
                parentLevels[i] = staticLevelData[i];

            } else {
                parentLevels[i] = data.find(element => element.level_no == i + 1);
            }
        }
        return parentLevels;
    }
    return (
        <>
            <StyledCardContainer>
                {data.map((entry, i) => {
                    if (entry.games.length > 0) {
                        return <div className="grid-card" key={i}>
                            <ResultsCard bgcolor={levelcolors[i].bgColor} textcolor={levelcolors[i].color} content={i + 1} trial>
                                <h5 className="mt-2 mb-2">Level {i + 1}</h5>
                                <span className="color-text-grey mb-2">{entry.games.length}/50 Games</span>
                                <CustomButton
                                    bgColor={COLORS.green}
                                    hover={COLORS.text_green}
                                    color={COLORS.text_dark_green}
                                    onClick={() => history.push(`/dashboard/games/${i + 1}`)}
                                    style={{ padding: "0 15px", height: 45, fontSize: 15, width: "60%" }}
                                >
                                    View Games
                            </CustomButton>
                            </ResultsCard>
                        </div>
                    } else {

                        return <div className="grid-card" key={i}><ResultsCard bgcolor={levelcolors[i].bgColor} textcolor={levelcolors[i].color} content={i + 1} trial>
                            <h5 className="mt-2 mb-2">Level {i + 1}</h5>
                            <span style={{ color: levelcolors[i].bgColor }}>Not Purchased</span>
                        </ResultsCard>
                        </div>

                    }

                })}

            </StyledCardContainer>

        </>
    )
}
